module.exports = __webpack_public_path__ + "media/close.e1db13a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/close.svg
// module id = ./src/templates/outSide/assets/img/close.svg
// module chunks = 0